import { useEffect, useRef } from "react";
import { X } from "lucide-react";

export default function VideoLightbox({ src, title, open, onClose }) {
  const videoRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    // Lock body scroll
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  useEffect(() => {
    if (open && videoRef.current) {
      videoRef.current.currentTime = 0;
      videoRef.current.play().catch(() => {});
    }
  }, [open]);

  if (!open) return null;

  return (
    <div
      data-testid="video-lightbox"
      role="dialog"
      aria-modal="true"
      aria-label={title}
      onClick={onClose}
      className="fixed inset-0 z-[100] bg-black/95 backdrop-blur-sm flex items-center justify-center p-4 md:p-10 animate-[fadeIn_.3s_ease-out]"
      style={{ animation: "fadeIn 0.3s ease-out" }}
    >
      {/* Close button */}
      <button
        onClick={onClose}
        data-testid="video-lightbox-close"
        aria-label="Sluit video"
        className="absolute top-5 right-5 md:top-8 md:right-8 z-10 w-12 h-12 flex items-center justify-center text-white border border-white/20 hover:border-cgprimary hover:bg-cgprimary transition-all duration-300"
      >
        <X size={22} />
      </button>

      {/* Title */}
      {title && (
        <div className="absolute top-5 left-5 md:top-8 md:left-8 z-10 text-white">
          <div className="text-[10px] tracking-[0.25em] uppercase text-cgprimary mb-1">
            Cargides Group
          </div>
          <div className="font-heading text-xl md:text-2xl font-semibold">{title}</div>
        </div>
      )}

      {/* Video */}
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative w-full max-w-md md:max-w-lg lg:max-w-xl mx-auto max-h-[90vh]"
      >
        <video
          ref={videoRef}
          src={src}
          controls
          autoPlay
          playsInline
          preload="auto"
          className="w-full h-auto max-h-[90vh] object-contain"
          data-testid="video-lightbox-player"
        />
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
      `}</style>
    </div>
  );
}
